
import { Vue, Component, Prop } from 'vue-property-decorator';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';
import { getCurrentTime } from '@/common/utils';

@Component({
  components: {},
})
export default class LookCOeder extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Prop()
  lookType!: string;

  columns = [
    {
      title: '店铺名称',
      dataIndex: 'shop_name',
      align: 'center',
    },
    {
      title: '高德订单号',
      dataIndex: 'amap_order_id',
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'goods_name',
      align: 'center',
    },
    // {
    //   title: '订单金额',
    //   dataIndex: 'order_price',
    //   align: 'center',
    // },
    // {
    //   title: '结算金额',
    //   dataIndex: 'settlement_amount',
    //   align: 'center',
    // },
    {
      title: '核销金额',
      dataIndex: 'verify_order_price',
      align: 'center',
    },
    {
      title: '抽佣比例',
      dataIndex: 'com_ratio',
      align: 'center',
      customRender: (text: any) => {
        return `${text * 100}%`;
      },
    },
    {
      title: '核销时间',
      dataIndex: 'verify_time',
      align: 'center',
    },
    {
      title: '抽佣金额',
      dataIndex: 'commission_amount',
      align: 'center',
    },
  ];

  pagination = {
    pageSize: 10,
    total: 0,
    current: 1,
    onChange: this.onChangePage,
  };

  visible = false;
  onClose() {
    this.visible = false;
  }
  params = {
    page: 1,
    pageSize: 10,
  };
  invoiceID = '';
  invoiceDataList = [];
  title = '';
  async init(record: any) {
    this.visible = true;
    // console.log(this.lookType, ' lookType');
    this.invoiceID = record.id;
    this.title = record.buyer.title;
    this.params.page = 1;
    this.params.pageSize = 10;
    this.invoiceDataList = [];
    this.pagination.total = 0;
    this.pagination.current = 1;
    await this.getInvoiceDataList(this.invoiceID, this.params);
  }
  async getInvoiceDataList(invoiceID: string, params: any) {
    let res = null;
    if (this.lookType === 'invoiceIndex') {
      res = await this.invoiceService.getInvoiceDataListByOrderId(invoiceID, params);
    } else {
      res = await this.invoiceService.getInvoiceDataList(invoiceID, params);
    }
    this.invoiceDataList = res.list;
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }
  onChangePage(page: number, pageSize: number) {
    this.params.page = page;
    this.params.pageSize = pageSize;
    this.getInvoiceDataList(this.invoiceID, this.params);
  }

  async onExport() {
    try {
      const res = await this.invoiceService.getInvoiceDataListByOrderIdExport(this.invoiceID, this.params);
      if (!res) {
        this.$message.error('导出失败');
        return;
      }
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = `${this.title}_订单列表_${getCurrentTime()}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      console.log(res, ' res');
    } catch (error) {
      this.$message.error('导出失败');
    }
  }
}
